<template>
  <div
    class="PlayerListWaitlistButtonView"
    :data-testid="`playerButtonList--${player.id}`"
  >
    <IconButton
      iconName="check"
      shape="circle"
      size="smedium"
      iconSize="smedium"
      :aria-label="`Approve ${player.name}’s sub request`"
      :aria-busy="isUpdating"
      :disabled="isUpdating"
      @click="handleClick"
    />
  </div>
</template>

<script lang="ts" setup>
import IconButton from "@/components/IconButton.vue";
import { supabaseClient } from "@/lib/database/supabase";
import haptic from "@/lib/utils/platform/haptic";
import { Player, RunWithSubRequests, Status, SubRequest } from "@shared/lib/database/query.types";
import { ref } from "vue";

const emit = defineEmits<{
  "update:subRequest": [subRequest: SubRequest],
  "update:status": [status: Pick<Status, "run_id" | "player_id" | "probability">],
}>();

const {
  run,
  player,
} = defineProps<{
  run: RunWithSubRequests,
  player: Pick<Player, "id" | "name">,
}>();

const isUpdating = ref(false);

async function handleClick () {
  haptic();

  const subRequest = run.sub_requests.find((subRequest) => subRequest.player_id === player.id);
  if (!subRequest) return;

  isUpdating.value = true;

  const {
    data: updatedSubRequest,
    error,
  } = await supabaseClient
    .from("sub_requests")
    .update({
      accepted_at: "now()",
    })
    .eq("id", subRequest.id)
    .select()
    .maybeSingle();

  if (error) {
    alert(error.message);
  } else if (updatedSubRequest) {
    emit("update:subRequest", updatedSubRequest);
    emit("update:status", {
      run_id: run.id,
      player_id: player.id,
      probability: updatedSubRequest.probability,
    });
  }

  isUpdating.value = false;
}
</script>
